import { Colors, Fonts } from '../../shared/theme';

export const mainStyles = {
  uploadBox: {
    display: 'flex',
    height: '140px',
    justifyContent: 'flex-end',
    alignItems: 'flex-end'
  },
  upload: {
    borderStyle: 'solid',
    borderColor: Colors.lightPurple,
    borderRadius: '5px',
    borderWidth: '1px',
    backgroundColor: 'transparent',
    height: '40px',
    width: '84px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  box_name_Tooltip: {
    paddingTop: '14px',
    paddingLeft: '12px',
    fontFamily: Fonts.type.KanitRegular,
    fontSize: Fonts.size.text14,
    color: Colors.white
  },
  box_prices_Tooltip: {
    paddingLeft: '16px',
    fontFamily: Fonts.type.KanitRegular,
    fontSize: Fonts.size.text14,
    color: Colors.white
  },
  imageBox: {
    backgroundColor: '#F8F8F8',
    height: '140px',
    width: '140px'
  },
  paddingWarning: {
    paddingTop: '8px'
  },
  displayinline: {
    display: 'inline-block'
  },
  displayinline_left_13px: {
    display: 'inline-block',
    marginLeft: '13px'
  }
};

